import { translationUploadData_en_part1 } from "./translationUploadData.en.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationUploadData_en_part2 } from "./translationUploadData.en.part2";
import { translationUploadData_en_part3 } from "./translationUploadData.en.part3";
import { translationUploadData_en_part4 } from "./translationUploadData.en.part4";

export const translationUploadData_en = defineTranslationTree({
  ...translationUploadData_en_part1,
  ...translationUploadData_en_part2,
  ...translationUploadData_en_part3,
  ...translationUploadData_en_part4,
});
